<template>
	<div
		:class="[openedClassname]"
		class="uni-panel"
		ref="panelRef"
	>
		<header
			@click="togglePanel"
			:class="disabledClassname"
			class="uni-header"
		>
			<div class="uni-header__content">
				<slot name="header-content"></slot>
			</div>
			<div
				:class="disabledClassname"
				class="uni-header__control"
			>
				<i @click.stop="togglePanel" class="fa fa-chevron-right"></i>
			</div>
		</header>
		<div
			v-if="panelOpened && !disabled"
			class="uni-content"
		>
			<slot></slot>
		</div>
	</div>
</template>

<script>
import {computed, nextTick, ref} from "vue";

export default {
	props: {
		panelKey: {
			type: Number,
		},
		panelOpenedKey: {
			type: [Number, String, Object],
			default: null
		},
		settingsContentRef: {
			default: null
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	setup(props, {emit}) {
		const panelRef = ref(null);
		const settingsContentReference = ref(props.settingsContentRef);
		
		const disabledClassname = computed(() => props.disabled ? 'disabled' : '');
		const panelOpened = computed(() => props.panelOpenedKey === props.panelKey);
		const openedClassname = computed(() => panelOpened.value && !props.disabled ? 'opened' : '');
		
		function togglePanel(event){
			event.stopImmediatePropagation();
			event.stopPropagation();
			if(props.disabled) return;
			emit('update:panelOpenedKey', panelOpened.value ? null : props.panelKey);
			if(!panelOpened.value && settingsContentReference.value){
				nextTick(() => {
					settingsContentReference.value.scrollTop = panelRef.value.offsetTop - 58;
				})
			}
		}
		
		return {
			togglePanel,
			panelOpened,
			disabledClassname,
			openedClassname,
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/ui/uni-panel/uni-panel";
@use "@/scss/ui/uni-panel/uni-header";
@use "@/scss/ui/uni-panel/uni-content";

</style>